__turbopack_context__.v({
  "buttons": "yAdh2W_buttons",
  "container": "yAdh2W_container",
  "content": "yAdh2W_content",
  "headline": "yAdh2W_headline",
  "headlineBody": "yAdh2W_headlineBody",
  "headlineTitle": "yAdh2W_headlineTitle",
  "heroSection": "yAdh2W_heroSection",
  "icon": "yAdh2W_icon",
  "page": "yAdh2W_page",
  "primaryButton": "yAdh2W_primaryButton",
  "section1": "yAdh2W_section1",
  "title": "yAdh2W_title",
});
